import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useCallback, useContext, useMemo, useState } from 'react';
import { noop } from "../../utils/noop";
import { MenuCheckboxGroupContext } from "./MenuCheckboxGroup";
import { MenuButton } from "./MenuButton";
import { ToggleCheckbox, ToggleSwitch } from "../Toggle";
import { ToggleContext } from "../Toggle/ToggleContext";
import { motion } from 'framer-motion';
/**
 * MenuItemCheckbox
 *
 * A MenuItem which can be checked. It composes
 * MenuItem and should be used within MenuCheckboxGroup.
 */

export var MenuCheckbox = React.forwardRef(function (_ref, forwardedRef) {
  var name = _ref.name,
      children = _ref.children,
      _ref$onSelect = _ref.onSelect,
      onSelect = _ref$onSelect === void 0 ? noop : _ref$onSelect,
      _ref$shouldCloseMenuO = _ref.shouldCloseMenuOnSelect,
      shouldCloseMenuOnSelect = _ref$shouldCloseMenuO === void 0 ? false : _ref$shouldCloseMenuO,
      checkedProp = _ref.checked,
      disabled = _ref.disabled,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'checkbox' : _ref$variant,
      other = _objectWithoutProperties(_ref, ["name", "children", "onSelect", "shouldCloseMenuOnSelect", "checked", "disabled", "variant"]); // If MenuCheckbox is being used within MenuCheckboxGroup,
  // use its context provided value to control state.


  var _useContext = useContext(MenuCheckboxGroupContext),
      onChange = _useContext.onChange,
      checkedContext = _useContext.checked;

  var handleSelect = useCallback(function () {
    onChange(name);
    onSelect();
  }, [name, onChange, onSelect]);
  var isChecked = typeof checkedProp === 'undefined' ? checkedContext.has(name) : checkedProp;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      tapped = _useState2[0],
      setTapped = _useState2[1];

  var onTapStart = function onTapStart() {
    return setTapped(true);
  };

  var onTapEnd = function onTapEnd() {
    return setTapped(false);
  };

  var toggleContext = useMemo(function () {
    return {
      tapped: tapped,
      checked: isChecked,
      focused: false,
      disabled: disabled,
      hovering: false
    };
  }, [tapped, isChecked, disabled]);
  return /*#__PURE__*/React.createElement(ToggleContext.Provider, {
    value: toggleContext
  }, /*#__PURE__*/React.createElement(motion.div, {
    onTapStart: onTapStart,
    onTapCancel: onTapEnd,
    onTap: onTapEnd
  }, /*#__PURE__*/React.createElement(MenuButton, _extends({}, other, {
    disabled: disabled,
    shouldCloseMenuOnSelect: shouldCloseMenuOnSelect,
    role: "menuitemcheckbox",
    type: "checkbox",
    onSelect: handleSelect,
    iconAfter: variant === 'switch' ? /*#__PURE__*/React.createElement(ToggleSwitch, null) : /*#__PURE__*/React.createElement(ToggleCheckbox, null),
    "aria-checked": isChecked,
    ref: forwardedRef
  }), children)));
});